import { viewModelMetadata } from '@descomplica/microfrontend-core';
import { useEffect, useMemo } from 'react';
import { container } from 'tsyringe';
export var useViewModel = function (ViewModel, props) {
    var vm = useMemo(function () {
        if (viewModelMetadata.isSingletonViewModel(ViewModel)) {
            if (!container.isRegistered(ViewModel)) {
                container.registerSingleton(ViewModel);
            }
        }
        return container.resolve(ViewModel);
    }, []);
    var isOriginalViewModel = useMemo(function () {
        if (!vm.__isInitialized__) {
            vm.__isInitialized__ = true;
            return true;
        }
        return false;
    }, []);
    useMemo(function () {
        if (!isOriginalViewModel) {
            return;
        }
        if (vm.onInit) {
            vm.onInit(props);
        }
    }, []);
    useEffect(function () {
        return function () {
            if (!isOriginalViewModel) {
                return;
            }
            if (vm.onDestroy) {
                vm.onDestroy();
            }
            if (viewModelMetadata.isSingletonViewModel(ViewModel)) {
                if (container.isRegistered(ViewModel)) {
                    container.unregister(ViewModel);
                }
            }
        };
    }, []);
    useEffect(function () {
        if (vm.onChanges) {
            if (!isOriginalViewModel) {
                return;
            }
            vm.onChanges(props);
        }
    }, [props]);
    return vm;
};
